import { Link } from 'react-router-dom'
import { useAuth, displayUser } from '../context/AuthContext'
import { decodeEntities } from '../lib/decodeEntities'
import verseLogo from '../assets/verse-logo.png'

export default function HeroSection() {
  const { user, profile } = useAuth()
  const currentUser = displayUser(user, profile)

  return (
    <section className="hero">
      <div className="hero__blobs">
        <div className="hero__blob hero__blob--1" />
        <div className="hero__blob hero__blob--2" />
        <div className="hero__blob hero__blob--3" />
      </div>

      <div className="hero__inner">
        <div className="hero__content">
          <div className="hero__eyebrow">
            <span>✨</span> {currentUser ? `Welcome back, ${decodeEntities(currentUser.displayName)}` : 'Your stories deserve a home'}
          </div>

          <h1 className="hero__title">
            {currentUser
              ? <>What will you <em>write today?</em></>
              : <>Where <em>every story</em> finds its readers</>
            }
          </h1>

          <p className="hero__desc">
            {currentUser
              ? 'Your feed is ready, your drafts are waiting, and new stories are being published right now.'
              : 'Verse is a creative writing community for fanfiction, original stories, and everything in between. Write, share, and discover worlds crafted by writers just like you.'
            }
          </p>

          <div className="hero__cta">
            {currentUser ? (
              <>
                <Link to="/write" className="btn btn-primary">Write a story</Link>
                <Link to="/feed" className="btn btn-ghost">My feed</Link>
              </>
            ) : (
              <>
                <Link to="/signup" className="btn btn-primary">Start Writing Free</Link>
                <Link to="/browse" className="btn btn-ghost">Explore stories</Link>
              </>
            )}
          </div>

        </div>

        <div className="hero__visual">
          <img
            src={verseLogo}
            alt="Verse"
            className="hero__logo"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              WebkitMaskImage: 'radial-gradient(ellipse 80% 75% at 50% 50%, #000 70%, transparent 100%)',
              maskImage: 'radial-gradient(ellipse 80% 75% at 50% 50%, #000 70%, transparent 100%)',
            }}
          />
        </div>
      </div>
    </section>
  )
}
